import styled from 'styled-components';
import {spacing, font} from '../../theme/variables';

export const StyledInputLabel = styled.span`
  font-size: ${font.size.body.small};
  display: block;
  font-weight: ${font.weight.bold};
  margin-bottom: ${spacing.xsmall}px;
`;